<template>
  <settings-modal
    class="savings-account-decline-modal t-savings-account-decline-modal"
  >
    <template slot="heading">Decline savings account {{ savingsAccountId }}?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-decline-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_SAVINGS_ACCOUNT_UPDATE } from '@/events/savingsAccount'

  // Models
  import SavingsAccount from '@/models/SavingsAccount'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import SavingsAccountApi from '@/services/Api/SavingsAccountApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'DeclineSavingsAccountModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        declineSavingsAccountApiRequest: new ApiRequest(SavingsAccountApi.decline, SavingsAccount)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      savingsAccountId () {
        return this.modal.data.savingsAccountId
      },
      loading () {
        return this.declineSavingsAccountApiRequest.loading
      },
      error () {
        return this.declineSavingsAccountApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.declineSavingsAccountApiRequest.execute(this.savingsAccountId)
          .then(savingsAccount => {
            this.$eventHub.$emit(EVENT_SAVINGS_ACCOUNT_UPDATE, savingsAccount)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Savings account has been successfully declined.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
